@if (introData) {
  <div id="main-content" class="wrapper has-padding margin-height zoom-margin"
    (focusout)="onFocusOutMainContent($event)">
    <div [innerHTML]="introData.welcome"></div>
    <div class="intro-center display-flex row-flex">
      <div class="has-background cool-gray-5 has-padding flex-space-ie flex-space flex-100">
        <div class="double-bottom-space double-top-space">
          <button class="bofa--button secondary outlined flex-button" tabindex="-1">Back</button>
          <button class="bofa--button secondary dark-blue" tabindex="-1">Save and continue</button>
        </div>
        <div [innerHTML]="introData.buttons"></div>
      </div>
      <div class="has-background cool-gray-5 has-padding flex-space-ie flex-space flex-100">
        <div class="double-top-space double-bottom-space">
          <div class="level justify">
            <div class="level-item pointer">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 23 23" version="1.1" aria-label="success icon" class="intro-image has-background  bofa--heading is-3 zoom-button icon-text">
                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g transform="translate(-300.000000, -401.000000)" fill-rule="nonzero">
                    <g transform="translate(82.000000, 150.000000)">
                      <g transform="translate(218.000000, 251.000000)">
                        <path d="M11.5,0.164285714 C5.25024286,0.164285714 0.164285714,5.25024286 0.164285714,11.5 C0.164285714,17.7497571 5.25024286,22.8357143 11.5,22.8357143 C17.7497571,22.8357143 22.8357143,17.7497571 22.8357143,11.5 C22.8357143,5.25024286 17.7497571,0.164285714 11.5,0.164285714 Z" fill="#012169"/>
                        <polyline fill="#FFFFFF" points="8.91821899 17 4 12.0304393 4.80190822 11.215795 8.91821899 15.3753138 18.1980918 6 19 6.81464435 8.91821899 17"/>
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
            </div>
            <div class="level-item pointer">
              <svg aria-label="Complete Icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 23 23" version="1.1" class="intro-image has-background  bofa--heading is-3 zoom-button icon-text">
                <defs>
                  <polygon id="path-1" points="16.131728 18 11.5 15.5845315 6.86827195 18 7.75354108 12.9400099 4 9.33068914 9.18413598 8.59494298 11.5 4 13.815864 8.59494298 19 9.33068914 15.2464589 12.9122459"/>
                </defs>
                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g transform="translate(-327.000000, -401.000000)">
                    <g transform="translate(327.000000, 401.000000)">
                      <circle fill="#E31837" cx="11.5" cy="11.5" r="11.5"/>
                      <mask fill="white">
                        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#path-1"/>
                      </mask>
                      <use fill="#FFFFFF" fill-rule="nonzero" xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#path-1"/>
                    </g>
                  </g>
                </g>
              </svg>
            </div>
            <div class="level-item pointer">
              <svg class="intro-image has-background  bofa--heading is-3 zoom-button icon-text" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 25 25" version="1.1" aria-label="Incomplete icon">
                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g transform="translate(-265.000000, -400.000000)" fill-rule="nonzero" stroke="#CCD3E1">
                    <g transform="translate(82.000000, 150.000000)">
                      <g transform="translate(184.000000, 251.000000)">
                        <path d="M11.5,0.164285714 C5.25024286,0.164285714 0.164285714,5.25024286 0.164285714,11.5 C0.164285714,17.7497571 5.25024286,22.8357143 11.5,22.8357143 C17.7497571,22.8357143 22.8357143,17.7497571 22.8357143,11.5 C22.8357143,5.25024286 17.7497571,0.164285714 11.5,0.164285714 Z"/>
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
            </div>
          </div>
        </div>
        <div [innerHTML]="introData.images"></div>
      </div>
      <div class="has-background cool-gray-5 has-padding flex-100" >
        <label for="input" class="double-top-space "> Field </label>
        <input type="text" class="intro-field-width" aria-hidden="true" id="input" tabindex="-1" />
        <div [innerHTML]="introData.error"></div>
      </div>
    </div>
    <div [innerHTML]="introData.howLong"></div>
    <div class="display-flex row-flex">
      <div class="has-background cool-gray-5 has-padding intro-center flex-space-ie flex-space flex-100">
        <div class="intro-min">
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 130 27" version="1.1" aria-label="30 mins icon">
            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" font-family="Connections" font-size="36" font-weight="normal">
              <g transform="translate(-326.000000, -438.000000)" fill="#C41230">
                <text>
                  <tspan x="324" y="464">~30 min.</tspan>
                </text>
              </g>
            </g>
          </svg>
        </div>
        <div [innerHTML]="introData.minutes"></div>
      </div>
      <div class="has-background cool-gray-5 has-padding intro-center flex-space-ie flex-space flex-100">
        <div class="double-bottom-space double-top-space">
          <button class="bofa--button secondary outlined" tabindex="-1">Save and finish later</button>
        </div>
        <div [innerHTML]="introData.saveAndFinish"></div>
      </div>
      <div class="has-background cool-gray-5 has-padding flex-100">
        <div class="level justify bottom-space">
          <div class="icon-text">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 91 28" version="1.1" aria-label="25 mins icon">
              <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g transform="translate(-297.000000, -489.000000)">
                  <g transform="translate(297.000000, 489.000000)" fill="#C41230">
                    <text font-family="Connections" font-size="36" font-weight="normal">
                      <tspan x="34" y="27">: 25</tspan>
                    </text>
                    <g fill-rule="nonzero">
                      <path d="M14,12.67 C13.9664,12.67 13.9384,12.6854 13.9048,12.6882 L10.605,8.2012 L9.478,9.03 L12.7694,13.5072 C12.7078,13.6612 12.67,13.825 12.67,14 C12.67,14.0574 12.6952,14.1078 12.7036,14.1638 L9.5956,16.7328 L10.4874,17.8136 L13.5912,15.2474 C13.7214,15.2908 13.8544,15.33 14,15.33 C14.7336,15.33 15.33,14.7336 15.33,14 C15.33,13.2664 14.7336,12.67 14,12.67" id="Fill-1"/>
                      <path d="M14,26.6 C7.0532,26.6 1.4,20.9482 1.4,14 C1.4,7.0518 7.0532,1.4 14,1.4 C20.9482,1.4 26.6,7.0518 26.6,14 C26.6,20.9482 20.9482,26.6 14,26.6 Z M14,0 C6.2804,0 0,6.2804 0,14 C0,21.7196 6.2804,28 14,28 C21.7196,28 28,21.7196 28,14 C28,6.2804 21.7196,0 14,0 L14,0 Z" id="Fill-2"/>
                      <path d="M14,23.8 C8.596,23.8 4.2,19.404 4.2,14.0028 C4.2,8.5974 8.596,4.2 14,4.2 C19.4026,4.2 23.8,8.5974 23.8,14.0028 C23.8,19.404 19.4026,23.8 14,23.8 Z M14,2.8 C7.8246,2.8 2.8,7.826 2.8,14.0028 C2.8,20.1768 7.8246,25.2 14,25.2 C20.1754,25.2 25.2,20.1768 25.2,14.0028 C25.2,7.826 20.1754,2.8 14,2.8 L14,2.8 Z" id="Fill-3"/>
                    </g>
                  </g>
                  <g transform="translate(297.000000, 489.000000)"/>
                </g>
              </g>
            </svg>
          </div>
        </div>
        <div [innerHTML]="introData.timeOut"></div>
      </div>
    </div>
    <div [innerHTML]="introData.submit"></div>
    <!-- needed for skip content off focus -->
    <div class="unClickableDiv">
      <input tabindex="-1" type="text" class="trasparentText" aria-hidden="true">
    </div>
  </div>
} @else {
  Loading Applicant User...
}

